import React from 'react';
import { CashinPosition } from '../components/turboLive/components/cashin/constants';

type CashinPositionOptions = typeof CashinPosition[keyof typeof CashinPosition];

const CashinPositionContext = React.createContext<{
    cashinPosition: CashinPositionOptions | null;
}>({
    cashinPosition: null
});

export default CashinPositionContext;
